interface EncryptionBadgeProps {
  encrypted: boolean
  className?: string
}

export function EncryptionBadge({ encrypted, className = '' }: EncryptionBadgeProps) {
  if (!encrypted) return null

  return (
    <span className={`text-[rgb(var(--np-status-ok))] ${className}`} title="End-to-end encrypted">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    </span>
  )
}
